class Produtos {
    static get $inject() {
        return ['gql']
    }

    constructor(gql) {
        this.gql = gql
    }

    async getFoto(empresaId, produtoId, version) {
        const query = gql`
            query GetProdutoFoto($empresaId: Int!, $produtoId: String!, $version: ProdutoFotoVersion!) {
                empresa: filial(id: $empresaId) {
                    id
                    produto(id: $produtoId) {
                        id
                        fotoUrl(version: $version) {
                            token
                        }
                    }
                }
            }
        `

        const variables = { empresaId, produtoId, version }

        const { empresa: { produto: { fotoUrl: { token } } } } = await this.gql.query(query, variables)

        return `/api/resume-operation/${token}`
    }

    createProduto(empresaId, filialId, produtoParams, foto) {
        const mutation = gql`
            mutation CreateProduto($empresaId: String!, $filialId: String!, $produtoParams: ProdutoParams!, $foto: Upload) {
                empresa(id: $empresaId) {
                    produto: createProduto(filialId: $filialId, produtoParams: $produtoParams, foto: $foto) {
                        id
                        codigo
                        descricao
                        codigoBarras
                        ncm
                        exTipi
                        cest
                        ativo
                        foto {
                            fileName
                        }
                        filial {
                            id
                        }
                    }
                }
            }
        `

        const variables = {
            empresaId: empresaId.toString(),
            filialId: filialId.toString(),
            produtoParams,
            foto
        }

        return this.gql.mutate(mutation, variables).then(({ empresa }) => empresa.produto)
    }

    updateProduto(empresaId, produtoId, produtoParams, foto) {
        const mutation = gql`
            mutation UpdateProduto($empresaId: String!, $produtoId: String!, $produtoParams: ProdutoParams!, $foto: Upload) {
                empresa(id: $empresaId) {
                    produto: updateProduto(produtoId: $produtoId, produtoParams: $produtoParams, foto: $foto) {
                        id
                        foto {
                            fileName
                        }
                        ativo
                        filial {
                            id
                        }
                    }
                }
            }
        `
        const { tipoDestinacao, ativo } = produtoParams

        const variables = {
            empresaId: empresaId.toString(),
            produtoId: produtoId.toString(),
            produtoParams: { tipoDestinacao, ativo },
            foto
        }

        return this.gql.mutate(mutation, variables).then(({ empresa }) => empresa.produto)
    }

    updateProdutoFoto(empresaId, produtoId, foto) {
        const mutation = gql`
            mutation UpdateProduto($empresaId: String!, $produtoId: String!, $foto: Upload!) {
                empresa(id: $empresaId) {
                    produto: updateProduto(produtoId: $produtoId, produtoParams: {}, foto: $foto) {
                        id
                        foto {
                            fileName
                        }
                    }
                }
            }
        `

        const variables = { empresaId: empresaId.toString(), produtoId, foto }

        return this.gql
            .mutate(mutation, variables)
            .then(({ empresa }) => empresa.produto)
    }

    createCodigoFornecedor(empresaId, produtoId, params) {
        const mutation = gql`
            mutation CreateCodigoFornecedor($empresaId: String!, $produtoId: String!, $params: CodigoFornecedorParams!) {
                empresa(id: $empresaId) {
                    codigo: createCodigoFornecedor(produtoId: $produtoId, codigoFornecedorParams: $params) {
                        id
                        codigo
                        codigoFornecedor
                        cnpjFornecedor
                    }
                }
            }
        `

        return this.gql
            .mutate(mutation, { empresaId: empresaId.toString(), produtoId, params })
            .then(({ empresa: { codigo } }) => codigo)
    }

    importCodigosFornecedores(empresaId, filialId, arquivo, formato) {
        const mutation = gql`
            mutation ImportacaoCodigosFornecedores($empresaId: String!, $filialId: String!, $arquivo: Upload!, $formato: CodigosFornecedoresFormato!) {
                empresa(id: $empresaId) {
                    tarefaId: importCodigosFornecedores(filialId: $filialId, arquivo: $arquivo, formato: $formato)
                }
            }
        `

        const variables = {
            empresaId: empresaId.toString(),
            filialId: filialId.toString(),
            formato,
            arquivo
        }

        return this.gql
            .mutate(mutation, variables)
            .then(({ empresa: { tarefaId } }) => tarefaId)
    }

    deleteCodigoFornecedor(empresaId, { id: codigoFornecedorId }) {
        const mutation = gql`
            mutation DeleteCodigoFornecedor($empresaId: String!, $codigoFornecedorId: String!) {
                empresa(id: $empresaId) {
                    codigoFornecedor: deleteCodigoFornecedor(id: $codigoFornecedorId) {
                        id
                    }
                }
            }
        `

        return this.gql
            .mutate(mutation, { empresaId: empresaId.toString(), codigoFornecedorId })
            .then(({ empresa: { codigoFornecedor } }) => codigoFornecedor)
    }
}

angular.module("eficienciaFiscalModule").service("Produtos", Produtos)
